/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedRefusalTypeList } from '../models/PaginatedRefusalTypeList';
import type { PatchedRefusalType } from '../models/PatchedRefusalType';
import type { RefusalType } from '../models/RefusalType';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsRefusalTypesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedRefusalTypeList
     * @throws ApiError
     */
    public clientsRefusalTypesList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedRefusalTypeList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-refusal-types/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns RefusalType
     * @throws ApiError
     */
    public clientsRefusalTypesCreate({
        requestBody,
    }: {
        requestBody: RefusalType,
    }): CancelablePromise<RefusalType> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-refusal-types/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns RefusalType
     * @throws ApiError
     */
    public clientsRefusalTypesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this refusal type.
         */
        id: number,
    }): CancelablePromise<RefusalType> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-refusal-types/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns RefusalType
     * @throws ApiError
     */
    public clientsRefusalTypesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this refusal type.
         */
        id: number,
        requestBody: RefusalType,
    }): CancelablePromise<RefusalType> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-refusal-types/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns RefusalType
     * @throws ApiError
     */
    public clientsRefusalTypesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this refusal type.
         */
        id: number,
        requestBody?: PatchedRefusalType,
    }): CancelablePromise<RefusalType> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-refusal-types/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsRefusalTypesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this refusal type.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-refusal-types/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
